__turbopack_context__.v({
  "button": "g5v7ra_button",
  "buttons": "g5v7ra_buttons",
  "container": "g5v7ra_container",
  "description": "g5v7ra_description",
  "header": "g5v7ra_header",
  "title": "g5v7ra_title",
});
